<div class="wrapper limit-width-on-desktop-float">
  <div class="heading-section">
    <h2 class="h2-bold">Great, one last step. Let’s create a password.</h2>
  </div>
  <div class="input-wrapper">
    <ion-item mode="ios" class="password-item" native>
      <ion-input label="Password" labelPlacement="floating" #passwordField (ionChange)="passwordFieldOnChange()" [(ngModel)]="password" type="{{ passwordType }}"
        class="ion-align-self-center"></ion-input>
      <ion-icon slot="end" src="assets/icon/input-icons/{{ passwordIcon }}.svg" class="password-icon"
        (click)="showPassword()">
      </ion-icon>
    </ion-item>
    <div style="margin-top:10px;">
      <small>
        <li [ngClass]="{'success-text': pwdhas8orMoreChar, 'unsuccessful-text': !pwdhas8orMoreChar}">Password must contain
          at least 8 characters.</li>
        <li [ngClass]="{'success-text': pwdHasLowercase, 'unsuccessful-text': !pwdHasLowercase}">Password must contain a
          lower case character.</li>
        <li [ngClass]="{'success-text': pwdHasUppercase, 'unsuccessful-text': !pwdHasUppercase}">Password must contain an
          upper case character.</li>
        <li [ngClass]="{'success-text': pwdHasSpecialChar, 'unsuccessful-text': !pwdHasSpecialChar}">Password must contain a
          special character.</li>
        <li [ngClass]="{'success-text': pwdHasNumericChar, 'unsuccessful-text': !pwdHasNumericChar}">Password must contain a
          numeric character.</li>
      </small>
    </div>
  </div>
  <div class="button-wrapper">
    <ion-button mode="ios" (click)="setNewPassword()" [disabled]="!enableSetPasswordButton" class="primary-button">Set password</ion-button>
  </div>
</div>
